/**
 * Simpletrip Travel Integration
 *
 * Entry point of rendering the application
 */
import routes from 'router/routes';

import { YILU_OVERRIDE_KEY, renderYiluApp, yiluEnv } from './index.wrapper';

yiluEnv.setVariables({
  YILU_API_PRODUCTION_ENVIRONMENT: import.meta.env.VITE_YILU_API_PRODUCTION_ENVIRONMENT,
  GOOGLE_ANALYTICS_MEASUREMENT_ID: import.meta.env.VITE_GOOGLE_ANALYTICS_MEASUREMENT_ID,
  GOOGLE_TAG_MANAGER_CONTAINER_ID: import.meta.env.VITE_GOOGLE_TAG_MANAGER_CONTAINER_ID,

  YILU_AMP_BACKEND_URL: import.meta.env.VITE_YILU_AMP_BACKEND_URL,
  YILU_AMP_STORE_ID: import.meta.env.VITE_YILU_AMP_STORE_ID,
  YILU_AMP_LOUNGE_VERTICAL_ID: import.meta.env.VITE_YILU_AMP_LOUNGE_VERTICAL_ID,
  YILU_AMP_PARKING_VERTICAL_ID: import.meta.env.VITE_YILU_AMP_PARKING_VERTICAL_ID,
  YILU_AMP_CAR_RENTAL_VERTICAL_ID: import.meta.env.VITE_YILU_AMP_CAR_RENTAL_VERTICAL_ID,
  YILU_AMP_LOUNGE_CATALOG_ID: import.meta.env.VITE_YILU_AMP_LOUNGE_CATALOG_ID,
  YILU_AMP_MEILI_CATALOG_ID: import.meta.env.VITE_YILU_AMP_MEILI_CATALOG_ID,
  YILU_AMP_EURAIL_VERTICAL_ID: import.meta.env.VITE_YILU_AMP_EURAIL_VERTICAL_ID,
  YILU_AMP_EURAIL_COUNTRY_PASS_CATALOG_ID: import.meta.env.VITE_YILU_AMP_EURAIL_COUNTRY_PASS_CATALOG_ID,
  YILU_AMP_EURAIL_GLOBAL_PASS_CATALOG_ID: import.meta.env.VITE_YILU_AMP_EURAIL_GLOBAL_PASS_CATALOG_ID,

  LOCALES_HOST_URL: import.meta.env.VITE_LOCALES_HOST_URL,
  PHONE_COUNTRY_CODE: import.meta.env.VITE_PHONE_COUNTRY_CODE,
  YILU_ENTERPRISE_PARTNER: import.meta.env.VITE_YILU_ENTERPRISE_PARTNER,
  ABTEST_ENABLED: import.meta.env.VITE_ABTEST_ENABLED,
  YILU_EMBEDDED_TI: import.meta.env.VITE_YILU_EMBEDDED_TI,
  YILU_MEILI_PTID: import.meta.env.VITE_YILU_MEILI_PTID,
  YILU_MEILI_MANAGE_PTID: import.meta.env.VITE_YILU_MEILI_MANAGE_PTID,
  YILU_LANDING_PAGE_ENABLED: import.meta.env.VITE_YILU_LANDING_PAGE_ENABLED,
  YILU_MEILI_MANAGE_ENABLED: import.meta.env.VITE_YILU_MEILI_MANAGE_ENABLED,
  YILU_MEILI_ALLOWED_HOSTS: import.meta.env.VITE_YILU_MEILI_ALLOWED_HOSTS,
  YILU_EURAIL_COUNTRY_PRIORITY_LIST: import.meta.env.VITE_EURAIL_COUNTRY_PRIORITY_LIST,
});

renderYiluApp({
  overrides: {
    // example of how it can be used
    [YILU_OVERRIDE_KEY.YILU_HEADER_LOGO]: (originalProps, OriginalComponent) => {
      return <OriginalComponent {...originalProps} />;
    },
  },
  defaultPath: routes.LOUNGES_SEARCH,
  assetPathOverrides: {
    parking: {
      sipImagePaths: ['https://placehold.co/290x180?text=Parking+1'],
    },
    lounges: {
      sipImagePaths: [null, null, 'https://placehold.co/290x180?text=Lounge+3'],
    },
  },
});
